import NetworkLogic from "../Shared/NetworkLogic";
import UIManager from "../Shared/UIManager";
import GameList from "../Models/GameList";
import ThirdGameItem from "./ThirdGameItem";
import ToggleItem from "../Common/ToggleItem";
import CommonToggleContainer from "../Common/CommonToggleContainer";
import Utils from "../Shared/Utils";
import Constant from "../Shared/Constant";
import AudioManager from "../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ThirdGamesListUI extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Animation)
    aniEnter: cc.Animation = null

    @property(cc.Prefab)
    pfbGameItem: cc.Prefab = null
    
    @property(cc.Widget)
    wgtNode: cc.Widget = null

    @property(cc.ScrollView)
    scvItems: cc.ScrollView = null
    
    @property(cc.Layout)
    layoutItems: cc.Layout = null

    @property(cc.Label)
    lbPlateform: cc.Label = null
    
    @property(cc.Label)
    lbTotal: cc.Label = null

    @property(cc.EditBox)
    ebSearch: cc.EditBox = null

    @property(cc.Integer)
    plateformID: number = 0

    @property(cc.Integer)
    gameTypeID: number = 0

    private _gamesList: {} = {}
    private _urlImgPrefix = ""
    private _gameItemPool: cc.NodePool = null

    onLoad () {
        this._gameItemPool = new cc.NodePool(ThirdGameItem)
    }

    onEnable () {
        this.lbPlateform.string = ""
        this.lbTotal.string = ""
        this.aniEnter.play()
        this.createGamesListToggle()
        Utils.hideGameNode()
    }

    onDisable () {
        this.plateformID = 0
        this.gameTypeID = 0
        this.toggleContainer.node.children.forEach(node => {
            node.destroy()
        });
    }

    onDestroy () {
        this._gameItemPool.clear()
    }

    onBtnClick (event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.active = false
        }
    }

    onToggleSelected (toggle: ToggleItem) {
        // 逻辑
        this.lbPlateform.string = toggle.userData["gameTitleCn"]
        this.ebSearch.string = ""
        this.plateformID = toggle.userData["id"]
        this.scvItems.stopAutoScroll()
        this.scvItems.setContentPosition(cc.v2(0, 0))

        while (this.layoutItems.node.children.length > 0) {
            this._gameItemPool.put(this.layoutItems.node.children[0])
        }        

        if (this._gamesList[this.plateformID]) {
            this.showGameItems(this._gamesList[this.plateformID])
        }else {
            UIManager.showLoadingUI()
            NetworkLogic.getGameList(this.plateformID, function (gameConfigs) {
                UIManager.hideLoadingUI();
                cc.log("==== thirdGamesLists gameConfigs:",gameConfigs);
                this._gamesList[this.plateformID] = gameConfigs.tabList
                this._urlImgPrefix = gameConfigs.imgPrefix
                this.showGameItems(this._gamesList[this.plateformID])
            }.bind(this))
        }
    }

    onTextChange (text, editbox, userData) {
        if (userData === "search") {
            this.searchGame(text)
        }
    }

    onScrollEvent (scrollView, eventType) {
        if (eventType === cc.ScrollView.EventType.SCROLLING) {
            this.checkShowItems()
        }
    }

    private checkShowItems () {
        let found = false

        for (let i = 0; i < this.layoutItems.node.children.length; i++) {
            const node = this.layoutItems.node.children[i];
            let gameItem = node.getComponent(ThirdGameItem)

            // 可见范围
            if (!gameItem.gameConfig && this.scvItems.node.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2(0, node.height * node.anchorY))).y > -this.scvItems.node.height * this.scvItems.node.anchorY) {
                gameItem.urlImgPrefix = this._urlImgPrefix
                gameItem.gameConfig = node.getChildByName("node")["gameConfig"]
                found = true
            }else if (found) {
                break
            }
        }
    }

    private searchGame (name) {
        for (let i = 0; i < this.layoutItems.node.children.length; i++) {
            const nodeItem = this.layoutItems.node.children[i]
            let node = nodeItem.getChildByName("node")
            if (node["gameConfig"].gameTitleCn.indexOf(name) === -1) {
                nodeItem.active = false
            }else {
                nodeItem.active = true
            }
        }
    }

    //模拟点击
    public clickGame (gameListId) {
        for (let i = 0; i < this.layoutItems.node.children.length; i++) {
            const nodeItem = this.layoutItems.node.children[i]
            let node = nodeItem.getChildByName("node");
            cc.log("====进入clickGame");
            if (node["gameConfig"].gameListId === gameListId) {
                //cc.Component.EventHandler.emitEvents(node.getComponent(cc.Button).clickEvents)
                cc.log("====进入clickGame  gameListId：",gameListId);

                node.getComponent(cc.Button).clickEvents[0].emit([]);
            }
        }
    }

    private showGameItems (gameConfigs) {
        this.lbTotal.string = "总共" + gameConfigs.length + "款小游戏"

        gameConfigs.forEach(gameConfig => {
            let node = this._gameItemPool.get()

            if (!node) {
                node = cc.instantiate(this.pfbGameItem)
            }
            
            node.width = this.layoutItems.node.width / 5
            node.height = this.layoutItems.node.width / 5
            node.parent = this.layoutItems.node

            let nodeBtn = node.getChildByName("node")
            let button = nodeBtn.getComponent(cc.Button)

            nodeBtn["gameConfig"] = gameConfig

            if (!button) {
                let clickEventHandler = new cc.Component.EventHandler()
                button = nodeBtn.addComponent(cc.Button)
                clickEventHandler.target = cc.find("Canvas/gameNode")
                clickEventHandler.component = "HallUI"
                clickEventHandler.handler = "onGameItemClick"
                button.clickEvents.push(clickEventHandler)
                button.transition = cc.Button.Transition.SCALE
                button.zoomScale = 0.9
            }
        }); 

        this.layoutItems.updateLayout()
        this.checkShowItems()
    }

    private createGamesListToggle () {
        let twoLevelList = []

        for (let i = 0; i < GameList.serverData["tabList"].length; i++) {
            const element = GameList.serverData["tabList"][i];
            if (parseInt(element.id) === this.gameTypeID) {
                twoLevelList = element.twoLevelList
                break
            }
        }

        for (let i = 0; i < twoLevelList.length; i++) {
            const gameConifg = twoLevelList[i];

            if (parseInt(gameConifg.entranceFlag) === 0) {
                continue
            }

            let toggle = this.toggleContainer.addDefaultToggle(gameConifg.gameTitleCn, gameConifg)

            if (parseInt(gameConifg.id) === this.plateformID) {
                this.toggleContainer.selectToggle(toggle)
            }
        }
    }
}
